import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import IconSettingClass from '../../../../../../components/settingsIcon';
import Select from 'react-select';
import { getAdminSettings, addUpdateAdminSettings, getCounters, getCostCenterLevels } from '../../../../../../store/actions';

const PPDAdminSettings = props => {
    const [costCenterList, setCostCenterList] = useState([]);
    const [selectedDepartmentCC, setSelectedDepartmentCC] = useState({});
    const [departmentCCIndex, setDepartmentCCIndex] = useState(null);
    const [departmentCCLevels, setDepartmentCCLevels] = useState([]);
    const [selectedDepartmentLevel, setSelectedDepartmentLevel] = useState({});
    const [selectedJobCC, setSelectedJobCC] = useState({});
    const [jobCCIndex, setJobCCIndex] = useState(null);
    const [jobCCLevels, setJobCCLevels] = useState([]);
    const [selectedJobLevel, setSelectedJobLevel] = useState({});
    const [selectedCounters, setSelectedCounters] = useState([]);
    const [countersList, setCountersList] = useState([]);

    useEffect(() => {
        getSettings(props.ClientDataReducer.companyShortName);
        setDepartmentCCIndex(props.PPD_ADMIN_SETTINGS_GET?.departmentCCIndex);
        setJobCCIndex(props.PPD_ADMIN_SETTINGS_GET?.jobCCIndex);
        let costCenters = Array.isArray(props.PARENT_COST_CENTERS) && props.PARENT_COST_CENTERS.map(cc => ({ ...cc, value: cc.treeIndex, label: cc.treeName }));
        setCostCenterList(costCenters || []);
        let selectedDepartment = costCenterList.find(el => el.value === departmentCCIndex);
        if (selectedDepartment) {
            setSelectedDepartmentCC(selectedDepartment);
            setCCLevels(selectedDepartment.numLevels, "department");
            let selectedLevel = departmentCCLevels.find(lv => lv.value === props.PPD_ADMIN_SETTINGS_GET.departmentCCLevel);
            if (selectedLevel) setSelectedDepartmentLevel(selectedLevel);
        }
        let selectedJob = costCenterList.find(el => el.value === jobCCIndex);
        if (selectedJob) {
            setSelectedJobCC(selectedJob);
            setCCLevels(selectedJob.numLevels, "job");
            let selectedLevel = jobCCLevels.find(lv => lv.value === props.PPD_ADMIN_SETTINGS_GET.jobCCLevel);
            if (selectedLevel) setSelectedJobLevel(selectedLevel);
        };
    }, [costCenterList.length, departmentCCLevels.length, jobCCLevels.length]);

    useEffect(() => {
        getCounters(props.ClientDataReducer.companyShortName);
        let counters = Array.isArray(props.COUNTERS) && props.COUNTERS.map(c => ({ label: c.counterName, value: c.counterName }));
        setCountersList(counters || []);
        setSelectedCounters(countersList.filter(counter => props.PPD_ADMIN_SETTINGS_GET?.counters?.includes(counter.value)));
    }, [countersList.length]);

    async function getSettings(companyShortName) {
        await props.getAdminSettings(companyShortName);
    };

    async function getCounters(companyShortName) {
        await props.getCounters(companyShortName);
    };

    async function updateSettings() {
        await props.addUpdateAdminSettings({
            companyShortName: props.ClientDataReducer.companyShortName,
            departmentCCIndex: selectedDepartmentCC.treeIndex,
            jobCCIndex: selectedJobCC.treeIndex,
            counters: selectedCounters.map(c => c.value),
            departmentCCLevel: selectedDepartmentLevel.value,
            jobCCLevel: selectedJobLevel.value
        });
    };

    async function onSelectDepartment(selected) {
        setSelectedDepartmentCC(selected);
        setCCLevels(selected.numLevels, "department");
    };

    function onSelectJob(selected) {
        setSelectedJobCC(selected);
        setCCLevels(selected.numLevels, "job");
    };

    function onSelectCounter(selected) {
        setSelectedCounters(selected);
    };

    function setCCLevels(numLevels, ccName) {
        let levels = [];
        for (let level = levels.length; level <= numLevels; level++) {
            levels.push({ label: level, value: level });
        };
        if (ccName === "department") setDepartmentCCLevels(levels);
        if (ccName === "job") setJobCCLevels(levels);
    };

    function onSelectDepartmentLevel(selected) {
        setSelectedDepartmentLevel(selected);
    };

    function onSelectJobLevel(selected) {
        setSelectedJobLevel(selected);
    };

    function onMenuOpen() {
        return;
    }

    return (
        <Accordion>
            <AccordionSummary
                expandIcon={<IconSettingClass />}
                aria-controls="panel1a-content"
                id="panel1a-header"
            >
                <Typography className="reportTitle">PPD Admin Settings</Typography>
            </AccordionSummary>

            <AccordionDetails>
                <div className="reportListAccording mar-0">
                    <div className="df align-items-center justify-content-between margin-top-10">
                        <button
                            className="btn reportBtn"
                            onClick={updateSettings}
                        >
                            Save
                        </button>
                    </div>
                    <div className="ec_setup_contact reg ">
                        <div className="SavedReports reportId df align-items-center justify-content-between margin-top-10">
                            <div className="input_line ssD_fiels">
                                <label>Department Tree Index</label>
                                <Select
                                    options={costCenterList}
                                    onChange={async selected => onSelectDepartment(selected)}
                                    onMenuOpen={onMenuOpen}
                                    value={selectedDepartmentCC}
                                    placeholder="Select Department Tree Index"
                                >
                                </Select>
                            </div>
                        </div>
                        <div className="SavedReports reportId df align-items-center justify-content-between margin-top-10">
                            <div className="input_line ssD_fiels">
                                <label>Department Level</label>
                                <Select
                                    options={departmentCCLevels}
                                    onChange={onSelectDepartmentLevel}
                                    onMenuOpen={onMenuOpen}
                                    value={selectedDepartmentLevel}
                                    placeholder="Select Department Level"
                                >
                                </Select>
                            </div>
                        </div>
                        <div className="SavedReports reportId df align-items-center justify-content-between margin-top-10">
                            <div className="input_line ssD_fiels">
                                <label>Job Tree Index</label>
                                <Select
                                    options={costCenterList}
                                    onChange={async selected => onSelectJob(selected)}
                                    value={selectedJobCC}
                                    placeholder="Select Job Tree Index"
                                >
                                </Select>
                            </div>
                        </div>
                        <div className="SavedReports reportId df align-items-center justify-content-between margin-top-10">
                            <div className="input_line ssD_fiels">
                                <label>Job Level</label>
                                <Select
                                    options={jobCCLevels}
                                    onChange={onSelectJobLevel}
                                    onMenuOpen={onMenuOpen}
                                    value={selectedJobLevel}
                                    placeholder="Select Job Level"
                                >
                                </Select>
                            </div>
                        </div>
                        <div className="SavedReports reportId df align-items-center justify-content-between margin-top-10">
                            <div className="input_line ssD_fiels">
                                <label>Counters</label>
                                <Select
                                    options={countersList}
                                    isMulti={true}
                                    onChange={onSelectCounter}
                                    value={selectedCounters}
                                    placeholder="Select Counters"
                                >
                                </Select>
                            </div>
                        </div>
                    </div>
                </div>
            </AccordionDetails>
        </Accordion>
    )
};

const mapStateToProps = ({ UserReducer, ClientDataReducer, PPDReducer, CostCenterReducer }) => {
    const { PPD_ADMIN_SETTINGS, PPD_ADMIN_SETTINGS_GET, COUNTERS } = PPDReducer;
    const { PARENT_COST_CENTERS, COST_CENTER_LEVELS } = CostCenterReducer;
    return { UserReducer, ClientDataReducer, PPD_ADMIN_SETTINGS, PPD_ADMIN_SETTINGS_GET, PARENT_COST_CENTERS, COST_CENTER_LEVELS, COUNTERS };
};

export default connect(mapStateToProps, {
    getAdminSettings, addUpdateAdminSettings, getCounters, getCostCenterLevels
})(PPDAdminSettings);